export default __webpack_public_path__ + "static/media/logo-card-1024w.7e59e8be.avif";